import React, { useRef, useState, useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import RainbowCoin from './RainbowCoin'

function FadeInCoin({ scale, rainbowSpeed, glowIntensity, position, isMobile }) {
  const groupRef = useRef()
  const [opacity, setOpacity] = useState(0)
  const [hasStarted, setHasStarted] = useState(false)

  useEffect(() => {
    // Start fade-in after 1.75 second delay
    const timer = setTimeout(() => {
      setHasStarted(true)
    }, 1750)

    return () => clearTimeout(timer)
  }, [])

  useFrame((state, delta) => {
    if (hasStarted && opacity < 1) {
      setOpacity(prev => Math.min(prev + delta * 2, 1)) // Fade in over 0.5 seconds
    }

    if (groupRef.current) {
      groupRef.current.traverse((child) => {
        if (child.material) {
          child.material.transparent = true
          child.material.opacity = opacity
        }
      })
    }
  })

  return (
    <group ref={groupRef}>
      <RainbowCoin 
        scale={isMobile ? scale * 0.7 : scale}
        rainbowSpeed={rainbowSpeed}
        glowIntensity={glowIntensity}
        position={position} 
      />
    </group>
  )
}

export default FadeInCoin
